import { useState, useEffect } from "react";
import { apiAddChannel, apiGetChannels } from "../../api/channels.api";
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Spinner,
  Text,
  Textarea,
  useToast,
} from "@chakra-ui/react";

import { CHANNEL_STATUSES } from "../../constant/channel_statuses";

export default function ModalAddChannel({ isOpen, onOpen, onClose, onOkAdd }) {
  const [channel, setChannel] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSave, setIsSave] = useState(false);
  const [isDirty, setIsDirty] = useState({});
  const formRules = {
    name: [
      {
        key: "required",
        message: "Vui lòng điền tên kênh.",
        validate: value => !value,
      },
      {
        key: "maxLength",
        message: "Tên kênh không được quá 100 ký tự.",
        validate: value => value && value.length > 100,
      },
    ],
    // description: [
    //   {
    //     key: "required",
    //     message: "Vui lòng điền mô tả.",
    //     validate: value => !value,
    //   },
    //   {
    //     key: "maxLength",
    //     message: "Mô tả không được quá 500 ký tự.",
    //     validate: value => value && value.length > 500,
    //   },
    // ],
    status: [
      {
        key: "required",
        message: "Vui lòng chọn trạng thái.",
        validate: value => !value,
      },
    ],
  };
  const [errorForm, setErrorForm] = useState({});
  const toast = useToast();

  useEffect(() => {
    if (isSave) {
      const formRulesKeys = Object.keys(formRules);
      const tempDirty = {};
      formRulesKeys.forEach(field => {
        tempDirty[field] = true;
      });
      setIsDirty(tempDirty);
      onSave();
    }
  }, [isSave]);

  useEffect(() => {
    validateForm();
    const tempDirty = {};
    Object.keys(formRules).forEach(field => {
      tempDirty[field] = channel[field] || isDirty[field] ? true : false;
    });
    setIsDirty(tempDirty);
  }, [channel]);
  const onSave = async () => {
    if (isSave && !validateForm()) {
      setLoading(true);
      const payload = {
        name: channel.name,
        description: channel.description,
        status: channel.status,
      };

      await apiAddChannel(payload).then(
        response => {
          toast({
            title: "Thêm mới thành công.",
            description: "Thêm mới thành công.",
            status: "success",
            duration: 3000,
            position: "top-right",
            isClosable: true,
          });
          setLoading(false);
          onOkAdd();
          setIsSave(false);
          setChannel({});
          setIsDirty({});
          onClose();
          return true;
        },
        error => {
          console.log(error);
          toast({
            title: error?.response?.data?.message || "Đã xảy ra lỗi.",
            position: "top-right",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setIsSave(false);
          setLoading(false);
        }
      );
    } else {
      setIsSave(false);
    }
  };
  const isError = (field, value) => {
    if (Object.keys(formRules).includes(field)) {
      const rules = formRules[field];
      const error = rules.find(rule => rule.validate(value));
      setErrorForm({
        ...errorForm,
        [field]: error,
      });
      return error;
    }
  };

  const validateForm = () => {
    let isErr = false;
    const errorList = {};
    for (const field in formRules) {
      const error = isError(field, channel[field]);
      errorList[field] = error;
      if (error) {
        isErr = true;
      }
    }
    setErrorForm(errorList);
    return isErr;
  };
  return (
    <Modal
      isCentered={true}
      size="full"
      blockScrollOnMount={false}
      isOpen={isOpen}
      onClose={() => {
        setChannel({});
        setIsDirty({});
        setIsSave(false);
        onClose();
      }}
    >
      <ModalOverlay />
      <ModalContent
        alignItems="center"
        width="600px"
        maxHeight="80vh!important"
        minHeight="unset!important"
        paddingLeft="80px"
        paddingRight="80px"
      >
        <ModalHeader>
          <Text textAlign="center" fontSize="18px">
            Thêm mới kênh
          </Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody width="100%">
          <Box width="100%" position="relative">
            <Grid marginBottom="10px" templateColumns="repeat(3, 1fr)" gap={6}>
              <GridItem
                style={{ display: "flex", alignItems: "center" }}
                colSpan={1}
              >
                Tên kênh <Text color="red">*</Text>
              </GridItem>
              <GridItem colSpan={2}>
                <FormControl isInvalid={errorForm.name && isDirty.name}>
                  <Input
                    value={channel.name}
                    onChange={e =>
                      setChannel({ ...channel, name: e.target.value })
                    }
                  />
                  {errorForm.name && (
                    <FormErrorMessage>
                      {errorForm.name.message}
                    </FormErrorMessage>
                  )}
                </FormControl>
              </GridItem>
            </Grid>

            <Grid marginBottom="10px" templateColumns="repeat(3, 1fr)" gap={6}>
              <GridItem
                style={{ display: "flex", alignItems: "center" }}
                colSpan={1}
              >
                Mô tả
              </GridItem>
              <GridItem colSpan={2} style={{ position: "relative" }}>
                <Textarea
                  value={channel.description}
                  onChange={e => {
                    setChannel({
                      ...channel,
                      description: e.target.value,
                    });
                  }}
                  resize="none"
                />
              </GridItem>
            </Grid>

            <Grid marginBottom="10px" templateColumns="repeat(3, 1fr)" gap={6}>
              <GridItem
                style={{ display: "flex", alignItems: "center" }}
                colSpan={1}
              >
                Trạng thái <Text color="red">*</Text>
              </GridItem>
              <GridItem colSpan={2} style={{ position: "relative" }}>
                <FormControl isInvalid={errorForm.status && isDirty.status}>
                  <Select
                    placeholder="Chọn trạng thái"
                    onChange={e => {
                      setChannel({
                        ...channel,
                        status: e.target.value,
                      });
                    }}
                    value={channel.status}
                  >
                    {CHANNEL_STATUSES?.map((ch, index) => {
                      return (
                        <option key={index} value={ch.value}>
                          {ch.label}
                        </option>
                      );
                    })}
                  </Select>
                  {errorForm.status && (
                    <FormErrorMessage>
                      {errorForm.status.message}
                    </FormErrorMessage>
                  )}
                </FormControl>
              </GridItem>
            </Grid>
          </Box>
        </ModalBody>

        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={() => {
              const formRulesKeys = Object.keys(formRules);
              const tempDirty = {};
              formRulesKeys.forEach(field => {
                tempDirty[field] = true;
              });
              setIsDirty(tempDirty);
              setIsSave(true);
            }}
          >
            {loading && <Spinner />}
            Tạo mới
          </Button>
          <Button
            variant="ghost"
            onClick={() => {
              setChannel({});
              setIsDirty({});
              setIsSave(false);
              onClose();
            }}
          >
            Huỷ
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
